const UserActionTypes = {
    FETCH_USER: "FETCH_USER",
    ADD_USER: "ADD_USER"
};

export default UserActionTypes;